// extracted by mini-css-extract-plugin
export default {"page-404":"NotFound_page-404__vgKQA","page-404__content":"NotFound_page-404__content__tt98c"};